module.exports = __webpack_public_path__ + "img/162-abkhazia.8d249c56.svg";